import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { imageSizeCss, motion, radius, rem, space } from '@gbi/ui';

import tokens from '../../assets/styles/tokens';
import config from '../../config';
import { variables } from '../../assets/styles/variables';
import { GS } from '../../constants/Brokers';
import { ReactComponent as UserGlyph } from '../../assets/images/svg/user-icon.svg';
import { getAccountInitials } from '../../util/helpers/userHelpers';

// The initials avatar and the header layout changes that go with it are for
// GoldSilver only. Every other broker keeps the original name/number block.
export const isCompactAccountHeader = config.brokerTheme === GS;

// The width below which the Header switches to its mobile layout (the CSS of
// every Header component and Header's isMobile). GoldSilver's Insider+ nav only
// fits beside the logo from 1280px; every other broker keeps the app's bpXl.
export const headerMobileBreakpoint = isCompactAccountHeader
  ? 1280
  : Number(variables.breakpoints.bpXl);

// Ring shown on hover and while the account menu is open (see HeaderAccountWrap).
export const avatarActiveBorderColor = tokens.color.action.accentSubtle;

// A light disc reads on the dark header of both brands. The border is
// transparent until active so the avatar never shifts.
export const AccountAvatarCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  ${imageSizeCss(46)}
  border: ${rem(space[2])} solid transparent;
  border-radius: ${radius.capsule};
  background-color: ${tokens.color.surface.page};
  color: ${tokens.color.text.brand};
  ${tokens.type.label[300]}
  user-select: none;
  transition: border-color ${motion.speed} ease-in-out;

  svg {
    width: 55%;
    height: 55%;
  }
`;

const AccountAvatar = ({ account }) => {
  const { t } = useTranslation();
  const initials = getAccountInitials(account);

  return (
    <AccountAvatarCircle role="img" aria-label={t('header.accountMenu')}>
      {initials || <UserGlyph />}
    </AccountAvatarCircle>
  );
};

AccountAvatar.propTypes = {
  account: PropTypes.shape({
    DisplayName: PropTypes.string,
    AccountCode: PropTypes.string,
    AccountType: PropTypes.number,
  }),
};

export default AccountAvatar;
